import { useState } from 'react';
import { FaPlay, FaTh, FaBars } from 'react-icons/fa';

import TopBar from '../TopBar/TopBar.jsx';
import ModalUpload from '../ModalUpload/ModalUpload.jsx';
import VideoModal from '../Home/PlayerModal/Player.jsx';
import ImageModal from '../Home/PlayerModal/ImageModal.jsx';
import PdfViewer from '../Home/PlayerModal/PdfViewer.jsx';
import MusicModal from '../Home/PlayerModal/MusicPlayer.jsx';

import { useFileExplorer } from './hooks/useFileExplorer.jsx';
import BackButton from './components/BackButton/BackButton.jsx';
import PlayAllCard from './components/PlayAllCard/PlayAllCard.jsx';
import FileCard from './components/FileCard/FileCard.jsx';

import styles from './Fileexplorer.module.css';
import fileCardStyles from './components/FileCard/FileCard.module.css';

const MUSIC_EXTENSIONS = ['.mp3', '.wav', '.wma'];

export default function FileExplorer() {
  const [viewMode, setViewMode] = useState('grid'); // 'grid' | 'list'

  const {
    token,
    access,
    nameUser,
    lastNameUser,
    buildFileUrl,
    isModalOpen,
    setIsModalOpen,
    isPlayerOpen,
    setIsPlayerOpen,
    isMusicOpen,
    setIsMusicOpen,
    isImageOpen,
    setIsImageOpen,
    selectedImage,
    pdfUrl,
    dados,
    mideaUrl,
    setMideaUrl,
    playlist,
    setPlaylist,
    currentPath,
    uploadProgress,
    editingItem,
    setEditingItem,
    newName,
    setNewName,
    musicFiles,
    findAlbumArt,
    getPaths,
    onHome,
    navigateBack,
    handleFolderClick,
    handleFileDownload,
    handlePlayer,
    handleMusicPlaylist,
    handleEdit,
    handleRename,
    handleDelete,
    handleShare,
    handleUpload,
    openUpload,
    cancelUpload,
    handleImageView,
    handlePdfView,
  } = useFileExplorer();

  const commitRename = (item) => {
    handleRename(item.name, newName);
    setEditingItem(null);
  };

  const userFolderName = `${nameUser} ${lastNameUser}`;
  const isInsideUsuario = currentPath.includes('/Usuario');
  const isMusicContext = currentPath.includes('/Musicas/');

  const renderFileCard = (item, { extra = null, forceMusicContext = false } = {}) => {
    const isEditing = editingItem?.name === item.name;

    return (
      <FileCard
        key={item.name}
        item={item}
        access={access}
        thumbUrl={buildFileUrl('download', `${currentPath}/${item.name}`)}
        isMusicContext={forceMusicContext}
        isEditing={isEditing}
        newName={newName}
        onNewNameChange={setNewName}
        onRenameCommit={() => commitRename(item)}
        onFolderOpen={handleFolderClick}
        onEditStart={handleEdit}
        onView={() =>
          item.extension === '.pdf' ? handlePdfView(item.name) : handleImageView(item.name)
        }
        onDownload={() => handleFileDownload(item.name)}
        onPlay={() => handlePlayer(item.name)}
        onDelete={handleDelete}
        onShare={handleShare}
        extra={extra}
        viewMode={viewMode}
      />
    );
  };

  return (
    <div className={styles.root}>
      <ModalUpload
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onUpload={handleUpload}
        access={access}
        cancelUpload={cancelUpload}
      />
      <VideoModal
        isPlayerOpen={isPlayerOpen}
        setIsPlayerOpen={setIsPlayerOpen}
        videoUrl={mideaUrl}
        setVideoUrl={setMideaUrl}
      />
      <MusicModal
        isMusicOpen={isMusicOpen}
        setIsMusicOpen={setIsMusicOpen}
        playlist={playlist}
        setPlaylist={setPlaylist}
      />
      <ImageModal
        isOpen={isImageOpen}
        imageUrl={selectedImage}
        onClose={() => setIsImageOpen(false)}
      />

      {pdfUrl && <PdfViewer pdfUrl={pdfUrl} />}

      {access <= 5 && (
        <TopBar
          token={token}
          access={access}
          onHome={onHome}
          uploadProgress={uploadProgress}
          currentPath={currentPath}
          onOpenUpload={openUpload}
          onFolderCreated={getPaths}
          onRefresh={getPaths}
        />
      )}

      <div className={styles.toolbar}>
        <button
          className={viewMode === 'grid' ? styles.toolbarActive : ''}
          onClick={() => setViewMode('grid')}
          title="Visualização em grade"
        >
          <FaTh />
        </button>
        <button
          className={viewMode === 'list' ? styles.toolbarActive : ''}
          onClick={() => setViewMode('list')}
          title="Visualização em lista"
        >
          <FaBars />
        </button>
      </div>

      <div className={viewMode === 'list' ? styles.gridList : styles.grid}>
        {currentPath && <BackButton onClick={navigateBack} viewMode={viewMode} />}

        {musicFiles.length > 1 && (
          <PlayAllCard onClick={() => handleMusicPlaylist(musicFiles, findAlbumArt()?.name)} />
        )}

        {dados?.map((item) => {
          // Caso pasta "Usuario": só renderiza a pasta do próprio usuário logado
          if (isInsideUsuario) {
            const isInsideUserFolder = currentPath.includes(userFolderName);
            if (isInsideUserFolder || item.name === userFolderName) {
              return renderFileCard(item);
            }
            return null;
          }

          // Caso pasta de Músicas: só renderiza faixas/pastas, com botão de player
          if (
            isMusicContext &&
            (MUSIC_EXTENSIONS.includes(item.extension.toLowerCase()) || item.isDirectory)
          ) {
            const albumArt = findAlbumArt();
            const extra =
              access <= 2 && !item.isDirectory ? (
                <div className={`${fileCardStyles.iconButtons} ${fileCardStyles.iconButtonsPlayer}`}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMusicPlaylist(item.name, albumArt?.name);
                    }}
                  >
                    <FaPlay className={fileCardStyles.playIcon} />
                  </button>
                </div>
              ) : null;

            return renderFileCard(item, { extra, forceMusicContext: true });
          }

          return renderFileCard(item);
        })}
      </div>
    </div>
  );
}